const getSurroundingFocusableElements = focusableEls => {
  let previous;
  let next;
  for (let i = 0; i < focusableEls.length; i++) {
    next = focusableEls[i + 1];
    if (focusableEls[i] === document.activeElement) {
      break;
    } else {
      previous = focusableEls[i];
    }
  }
  return {
    previous,
    next
  };
};
const getUntabbablePills = ref => {
  var _ref$current$querySel, _ref$current;
  return Array.from((_ref$current$querySel = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll('button[tabindex="-1"]')) !== null && _ref$current$querySel !== void 0 ? _ref$current$querySel : []);
};

export { getSurroundingFocusableElements as a, getUntabbablePills as g };
//# sourceMappingURL=index-PH3sRi3V.js.map
